<mat-form-field appearance="fill" style="width:100%; overflow:hidden;">
    <mat-label>Inventory ID</mat-label>
    <input matInput [(ngModel)]="inventoryID" placeholder="Inventory ID" (focus)="onFocus()" (blur)="onBlur()"
        (keyup.enter)="onEnter()" #inventoryIDInput>

    <button *ngIf="!isSearching" matSuffix mat-icon-button (click)="openItemSearch()">
        <mat-icon matSuffix>search</mat-icon>
    </button>
    <mat-spinner *ngIf="isSearching" matSuffix diameter="24"></mat-spinner>
</mat-form-field>

<ng-template #itemSearchDialogTemplate>
    <h2 matDialogTitle>Item Search</h2>
    <mat-dialog-content style="width: 90vw;">
        <!-- <table>
            <tbody *ngFor="let item of itemSearchResults">
                <button mat-stroked-button style="width:100%; text-align:left;" [mat-dialog-close]="item">
                    <tr>
                        <td>
                            <mat-chip-list>
                                <mat-chip
                                    [style.backgroundColor]="mayerfabrics.LifeCycleColor(item.LifeCycle || 'inherited')"
                                    [style.color]="mayerfabrics.LifeCycleContrastColor(item.LifeCycle || 'inherited')"
                                    class="inventory-id-chip">
                                    {{item.InventoryID}}
                                </mat-chip>
                            </mat-chip-list>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">{{item.Description}}</td>
                    </tr>
                </button>
            </tbody>
        </table> -->
        <button *ngFor="let item of itemSearchResults" mat-stroked-button
            style="width:95%; margin: 5px 0; padding: 15px 0 15px 1em; text-align:left; white-space: normal; line-height: unset;"
            [style.backgroundColor]="mayerfabrics.LifeCycleColor(item.LifeCycle || 'inherited')"
            [style.color]="mayerfabrics.LifeCycleContrastColor(item.LifeCycle || 'inherited')"
            [mat-dialog-close]="item">
            {{item.InventoryID}} - {{item.Description}}
        </button>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-stroked-button matDialogClose color="accent">Cancel</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #itemTreeSearchDialogTemplate>

</ng-template>